import Service from 'react-reservice';

import { ESymbolCategory, ISymbol } from '@aqx-core/common/api/market';
import { EWatchlistCategory } from '@aqx-core/common/api/watchlist';

export interface ITradeWatchlistServiceContext {
  watchlistLoading?: boolean;
  allSymbolsLoading?: boolean;
  selectedWatchListFilter?: EWatchlistCategory;
  selectedSymbolCategory?: ESymbolCategory;
  symbolCategories: ESymbolCategory[];

  displayWatchlistSymbolIds: string[];
  displayWatchlistSymbols: Record<string, ISymbol>;

  // All symbols retrieved from API
  allWatchlistSymbols: Record<string, ISymbol>;

  /**
   * Flag to indicate whether UI should reload Favourites list on watchlist dependency
   * Used mainly on Trade UI
   */
  shouldRefetchFavourites: boolean;
}

const defaultContext: ITradeWatchlistServiceContext = {
  watchlistLoading: true,
  allSymbolsLoading: true,
  selectedWatchListFilter: undefined,
  selectedSymbolCategory: undefined,
  symbolCategories: [],

  displayWatchlistSymbolIds: [],
  displayWatchlistSymbols: {},
  allWatchlistSymbols: {},

  shouldRefetchFavourites: false
};

class TradeWatchlistService extends Service<ITradeWatchlistServiceContext> {
  constructor() {
    super();

    this.context = defaultContext;
  }

  setWatchlistLoading = (values: boolean) => {
    this.context.watchlistLoading = values;
  };

  setAllSymbolsLoading = (values: boolean) => {
    this.context.allSymbolsLoading = values;
  };

  setSelectedWatchListFilter = (values?: EWatchlistCategory) => {
    this.context.selectedWatchListFilter = values;
  };

  setSelectedSymbolCategory = (values?: ESymbolCategory) => {
    this.context.selectedSymbolCategory = values;
  };

  setSymbolCategories = (values: ESymbolCategory[]) => {
    this.context.symbolCategories = values;
  };

  setDisplayWatchlistSymbols = (values: Record<string, ISymbol>) => {
    this.context.displayWatchlistSymbols = values;
  };

  setDisplayWatchlistSymbolIds = (values: string[]) => {
    this.context.displayWatchlistSymbolIds = values;
  };

  setAllWatchlistSymbols = (values: Record<string, ISymbol>) => {
    this.context.allWatchlistSymbols = values;
  };

  setShouldRefetchFavourites = (shouldRefetchFavourites: boolean) => {
    this.context.shouldRefetchFavourites = shouldRefetchFavourites;
  };
}

export const tradeWatchlistService = new TradeWatchlistService();
